import GameModel from "../../../core/src/model/GameModel";
import ConsoleUtil from "../../../core/src/utils/ConsoleUtil";
import Utils from "../../../core/src/utils/Utils";
import GetGameRequest from "./GetGameRequest";

export default class GetJackpotsRequest extends GetGameRequest {
  get requestData(): any {
    ConsoleUtil.log('GetJackpotsRequest');

    let userId = GameModel?.playerConfig?.userId || undefined;

    const { gameId, serverVersion } = GameModel.apiConfig;

    return {
      "action": "getGlobalGameJackpots",
      "gameId": gameId,
      "userId": userId,
      'serverVersion': serverVersion,
      'gameVersion': Utils.isNullOrWhiteSpace(GameModel.apiConfig.gameVersion) ? GameModel?.gameVersion : GameModel.apiConfig.gameVersion,
      'deviceInfo': Utils.getDeviceInfo(),
      "playerToken": GameModel.playerToken
    };
  };

  get path() {
    let domain =
      GameModel.apiConfig.domain ||
      window.location.protocol + "//" + window.location.hostname;
    let port = GameModel.apiConfig.port;
    let portString = port ? ":" + port : "";

    return domain + portString + "/game";
  };

  get method(): string {
    return "POST";
  };
};